import React from "react";
import DictTree from "./dictTree"
import DictForm from "./dictForm"

const Dict = ():JSX.Element => {
    return (
        <div className="flex">
            <DictTree/>
            <DictForm/>
        </div>
    )
}
export default Dict